import { GameRecordBase } from '../../shared/models/game-record-base';
import type { GameRecordOptions } from '../../shared/models/game-record-base';

/**
 * NBA-specific GameRecord.
 * - Denominator is W+L only (no ties in denominator).
 * - zeroGamesValue: 0 (return 0 when no games played).
 * - zeroPctValue: -1 (PctNaN returns -1 when no games played — used for sorting unplayed teams last).
 */
export class NbaGameRecord extends GameRecordBase {
  static readonly NBA_OPTIONS: Partial<GameRecordOptions> = {
    includeTiesInDenominator: false,
    zeroGamesValue: 0,
    zeroPctValue: -1,
  };

  constructor(fakeObs: KnockoutObservable<number | undefined>) {
    super(fakeObs, NbaGameRecord.NBA_OPTIONS);
  }
}
